import React from "react";
import AnimateLine from "../../common/AnimateLine";
import Testimonial from "../home/Testimonial";
import HistoryArea from "./HistoryArea";

function AboutWrap() {
  return (
    <>
      <div className="dlplatforms-wrap">
        <AnimateLine />
        {/* <WhyChooseUs /> */}
        {/* <AboutArea image="/img/logo-dark.svg"/> */}
        {/* <FeaturesArea/> */}
        <HistoryArea/>
        {/* <Testimonial/> */}
        {/* <TeamWrap/> */}
        {/* <LatesPost/> */}
        <Testimonial />

      </div>
    </>
  );
}

export default AboutWrap;
